export enum PageEnum {
  Home = '/home',
}
